import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles'
import { defineMessages, FormattedMessage } from 'react-intl';

import Loader from '../../../components/Loader';
import School from '../../../components/School';
import style from './ProgramList.scss';

const localMessages = defineMessages({
  noMoreSavedPrograms: {
    id: 'schedule.NoMoreSavedPrograms',
    defaultMessage: 'You have scheduled/expressed interest in all your saved programs. Hooray!',
    description: 'The string shown when all saved programs have been scheduled',
  },
});

class ProgramList extends React.PureComponent {
  showSchoolDetail = (directorySchoolId, directoryProgramId) => {
    this.props.showSchoolDetail(directorySchoolId, directoryProgramId);
  };

  render() {
    const { programs, initScheduling, programClick, schools, user, removeNoMatchingTimeSlot } = this.props;
    if (schools.loading || programs.loading) {
      return <Loader />;
    }

    if (!schools || schools.normalSchools.result.length === 0 || !programs || programs.result.length === 0) {
      return null;
    }

    const displayableDirectoryProgramIds = programs.result
      .filter(
        program =>
          program.schedule &&
          !program.appointment &&
          !program.schedule.expression_of_interest.id &&
          !program.schedule.no_matching_time_slot,
      )
      .map(program => program.directory_program.id);

    if (displayableDirectoryProgramIds.length === 0) {
      return (
        <div className={style.programListEmpty}>
          <FormattedMessage {...localMessages.noMoreSavedPrograms} />
        </div>
      );
    }

    const programList = _.flatten(
      schools.normalSchools.result.map(id =>
        schools.normalSchools.entities.school[id].programs.result
          .filter(directoryProgramId => displayableDirectoryProgramIds.includes(directoryProgramId))
          .map(directoryProgramId => ({
            directorySchoolId: id,
            directoryProgramId,
            distance: parseFloat(schools.normalSchools.entities.school[id].distance),
            savedAt: schools.normalSchools.entities.school[id].programs.entities.program[directoryProgramId].saved_at,
          })),
      ),
    );

    return programList.map(({ directorySchoolId, directoryProgramId }) => (
      <div key={`${directorySchoolId}-${directoryProgramId}`} className={style.programListCardWrapper}>
        <School
          {...schools.normalSchools.entities.school[directorySchoolId]}
          firstName={user.firstName}
          loggedIn
          singleProgramId={directoryProgramId}
          onClick={() => this.showSchoolDetail(directorySchoolId, directoryProgramId)}
          programClick={programClick}
          schedule
          scheduleProgram={programs.result.find(program => program.directory_program.id === directoryProgramId)}
          initScheduling={initScheduling}
          removeNoMatchingTimeSlot={removeNoMatchingTimeSlot}
        />
      </div>
    ));
  }
}

ProgramList.propTypes = {
  programs: PropTypes.shape().isRequired,
  schools: PropTypes.shape().isRequired,
  user: PropTypes.shape().isRequired,
  showSchoolDetail: PropTypes.func.isRequired,
  programClick: PropTypes.func.isRequired,
  initScheduling: PropTypes.func.isRequired,
  removeNoMatchingTimeSlot: PropTypes.func.isRequired,
};

export default withStyles(style)(ProgramList);
